// extracted by mini-css-extract-plugin
export default {"button":"StoreSelectorButton_button__zKlIP","visible":"StoreSelectorButton_visible__lXPp9","label":"StoreSelectorButton_label__YHiY-"};